import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Home from './Home';

export default function HomeFr() {
  const { i18n } = useTranslation();
  useEffect(() => { if (i18n.resolvedLanguage !== 'fr') i18n.changeLanguage('fr'); }, [i18n]);
  return <Home />;
}
